import { axiosSwagger } from "@/axios";
import _cloneDeep from 'lodash/cloneDeep';

const sortLocationsDeep = (locations = []) => {
    return [...(locations || [])]
        .map((location) => ({
            ...location,
            childLocations: sortLocationsDeep(location.childLocations || []),
        }))
        .sort((a, b) =>
            (a?.location || "").localeCompare((b?.location || ""), undefined, {
                sensitivity: "base",
                numeric: true,
            })
        );
};


export const state = {
    fileLocation: {
        treeLoading: false, // para sa tree ui
        displayLoading: false, // para ni sa display lang
        
        data: {
          id: 0,
          location: "Physical Location",
          description: "",
          childLocations: [], // child locations
        },
        total: 0,
  
        // selected location sa tree ui
        selectedData: {},
    },
    currentFileLocation: {
        loading: false,
        data: {},
        total: 0,
  
        selectedID: null,
    },
    // select tree field for file location
    selectFileLocation: {
        loading: false,
        data: [],
        total: 0,
    },
    pagination: {
        grid: {
          start: 0,
          limit: 0,
        },
        table: {
          start: 0,
          limit: -1,
        }
      }
}


export const getters = {
}


export const mutations = {
    // MY FILE LOCATION
    fileLocationLoading: (state, data) => {
        if(data.type === 'tree-ui'){
            state.fileLocation.treeLoading = data.loading;
        }
        else if(data.type === 'display-ui'){
            state.fileLocation.displayLoading = data.loading;
        }
    },
    setFileLocationData: (state, data) => {
        state.fileLocation.data.childLocations = data;
    },
    setFileLocationTotal: (state, total) => {
        state.fileLocation.total = total;
    },
    selectLocation: (state, data) => {
        state.fileLocation.selectedData = data;
    },
    // CURRENT FILE LOCATION
    currentFileLocationLoading: (state, loading) => {
        state.currentFileLocation.loading = loading;
    },
    setCurrentFileLocationData: (state, data) => {
        state.currentFileLocation.data = data;
    },
    setCurrentFileLocationTotal: (state, total) => {
        state.currentFileLocation.total = total;
    },
    selectLocationID: (state, id) => {
        state.currentFileLocation.selectedID = id;
    },
    removeFileLocation: (state, id) => {
        if(state.fileLocation.data.childLocations?.length){
            const myLocationIndex = state.fileLocation.data.childLocations.findIndex((item) => item.id === id);
    
            if(myLocationIndex !== -1){
                state.fileLocation.data.childLocations = state.fileLocation.data.childLocations.filter(
                    (el) => el.id !== id
                );
            }
        }
        
        if(state.currentFileLocation.data?.length){
            const currentLocationIndex = state.currentFileLocation.data.findIndex((item) => item.id === id);
    
            if(currentLocationIndex !== -1){
                state.currentFileLocation.data = state.currentFileLocation.data.filter(
                    (el) => el.id !== id
                );
            }
        }

    },
    // SELECT FIELD FOR FILE LOCATION
    selectFileLocationLoading: (state, loading) => {
        state.selectFileLocation.loading = loading;
    },
    setSelectFileLocationData: (state, data) => {
        // state.selectFileLocation.data = data;

        state.selectFileLocation.data = setModifiedLocationTree( _cloneDeep(data) );
    },
    setSelectFileLocationTotal: (state, total) => {
        state.selectFileLocation.total = total;
    },
    setCustomSelectFileLocationData: (state, data) => {
        const copySelectFileLocation =  _cloneDeep(state.selectFileLocation.data); // make sure na di ni empty

        state.selectFileLocation.data = modifiedData( copySelectFileLocation, data )
    },
    // pagination GRID
    setPaginationGridStart: (state, data) => {
        state.pagination.grid.start = data;
    },
    setPaginationGridLimit: (state, data) => {
        state.pagination.grid.limit = data;
    },
    // pagination TABLE
    setPaginationTableStart: (state, data) => {
        state.pagination.table.start = data;
    },
    setPaginationTableLimit: (state, data) => {
        state.pagination.table.limit = data;
    },
}


export const actions = {
    // READ MY FILE LOCATION
    async readMyFileLocation({ commit }, type) {
        commit("fileLocationLoading", {type, loading: true});

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileLocation/My/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const sortedData = sortLocationsDeep(response.data);

            commit("setFileLocationData", sortedData);
            commit("setFileLocationTotal", sortedData.length);
            commit("fileLocationLoading", {type, loading: false});

            return {
                ...response,
                data: sortedData,
            };
        })
        .catch(() => {
            commit("fileLocationLoading", {type, loading: false});
        });
    },
    // READ TREE FILE LOCATION BY ID
    async readTreeFileLocationById({ commit }, id) {
        commit("fileLocationLoading", {type: 'tree-ui', loading: true});

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileLocation/Child/${id}/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const sortedData = sortLocationsDeep(response.data);

            commit("fileLocationLoading", {type: 'tree-ui', loading: false});

            return {
                ...response,
                data: sortedData,
            };
        })
        .catch(() => {
            commit("fileLocationLoading", {type: 'tree-ui', loading: false});
        });
    },
    // READ FILE LOCATION BY PARENT ID
    async readLocationByParentId({ commit }, obj) {
        // if e pakita pa ang loading effect or dili na
        obj.isLoad ? commit("currentFileLocationLoading", true) : "";
        
        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileLocation/Child/${obj.id}/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const sortedData = sortLocationsDeep(response.data);

            commit("setCurrentFileLocationData", sortedData);
            commit("setCurrentFileLocationTotal", sortedData.length);
            obj.isLoad ? commit("currentFileLocationLoading", false) : "";

            return {
                ...response,
                data: sortedData,
            };
        })
        .catch(() => {
            obj.isLoad ? commit("currentFileLocationLoading", false) : "";
        });
    },
    // READ FILE LOCATION BY DELIVERY UNIT ID. para ni siya sa select form na tree field 
    // eslint-disable-next-line no-unused-vars
    async readFileLocationByDeliveryUnitId({ commit }, id) {
        commit("selectFileLocationLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileLocation/DeliveryUnit/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const sortedData = sortLocationsDeep(response.data);

            commit("setSelectFileLocationData", sortedData);
            commit("setSelectFileLocationTotal", sortedData.length);
            commit("selectFileLocationLoading", false);

            return {
                ...response,
                data: sortedData,
            };
        })
        .catch(() => {
            commit("selectFileLocationLoading", false);
        });
    },
    // READ TREE SELECT FIELD SA FILE LOCATION BY ID
    async readSelectTreeFieldFileLocationById({ commit }, id) {
        commit("selectFileLocationLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileLocation/Child/${id}/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const sortedData = sortLocationsDeep(response.data);

            commit("selectFileLocationLoading", false);

            return {
                ...response,
                data: sortedData,
            };
        })
        .catch(() => {
            commit("selectFileLocationLoading", false);
        });
    },
    // CREATE FILE LOCATION 
    // eslint-disable-next-line no-unused-vars
    async createFileLocation({ commit }, data) {
        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
        
        return await axiosSwagger
        .post(`/api/FileLocation/Create/${userData?.deliveryUnit?.id}`, data)
        .then((response) => {

            return response;
        });
    },
    // DELETE FILE LOCATION 
    async deleteFileLocation({ commit }, id) {
        return await axiosSwagger.delete(`/api/FileLocation/Remove/${id}`)
            .then((response) => {
            commit("removeFileLocation", id);

            return response;
        });
    },
    // UPDATE FILE LOCATION 
    // eslint-disable-next-line no-unused-vars
    async updateFileLocation({ commit }, data) {
        return await axiosSwagger
        .put(`/api/FileLocation/Update/${data.id}`, data)
        .then((response) => {

            return response;
        });
    },
    // Get File Location by Id
    async readTargetLocationPathById({ commit }, id) {
        commit("selectFileLocationLoading", true);

        return await getAllPath(id)
            .then(() => {
                commit("setCustomSelectFileLocationData", _path);
                _path = []; // reset path

                setTimeout(() => {
                    commit("selectFileLocationLoading", false);
                }, 200);
                
            })
            .catch((e) => {
                commit("selectFileLocationLoading", false);

                throw e;
            });
    }
}



const setModifiedLocationTree = (arr) => {
    if(!arr.length){
        return []
    }

    return arr.map((e) => {
        e.childLocations = null;

        return e;
    })
}


let _path = [];
async function getAllPath(id) {

    if(id){
        
        await axiosSwagger
            .get(`/api/FileLocation/${id}`, { removeToast: true })
            .then(async (response) => {
                _path.unshift(response.data);
    
                if(response.data.parentId !== null){
                    await getAllPath(response.data.parentId);
                }
                else{
                    return _path;
                }
            })
            .catch(() => {
                throw("error getAllPath");
            })
    }

    return _path;

}

// rootLocation: my location data
// targetLocation: mao nani na path sugod sa root paduong sa target location data
const modifiedData = (rootLocation, targetLocation) => {
    if( (rootLocation?.length ?? false) && (targetLocation?.length ?? false) ){
        let targetArr = setCustomCascadeSelectTreeData(targetLocation);

        rootLocation.forEach(e => {
            if(e.id === targetArr[0].id){
                // replace with cascade data
                e.childLocations = targetArr[0].childLocations;
            }
        });


        return rootLocation;
    }
  
    return rootLocation;
};



function setCustomCascadeSelectTreeData(array) {
    if(array.length > 1){
        let pop = array.pop();
        let len = array.length;

        array[len-1].childLocations = [pop];

        setCustomCascadeSelectTreeData(array);
    }

    return array;
}





// const modifiedLocationTreeData = (treeData, depth = 0) => {
//     treeData.depth = depth;

//     if(depth === 1){
//         treeData.childLocations = null;
//         treeData.last = 'mao ni ang last';
//     }
  
//     // if naay child locations
//     if (treeData.childLocations && treeData.childLocations.length) {
//       treeData.childLocations.forEach((childLocation) => {
//         modifiedLocationTreeData(childLocation, depth + 1);
//       });
//     }
  
//     return treeData;
// };